import { StandardEvents } from '@shopify/events';

// Use the same standard cart event and count as Horizon's original cart-icon.
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (Number.isFinite(count)) {
      document.querySelectorAll('[data-lg-cart-count]').forEach(element => element.textContent = String(count));
    }
  }).catch(() => {});
});
